import { RouteName } from "@/router/types";

export interface SideBarState {
  sideBarOpen: boolean;
}

export const enum SideBarAction {}

export const enum SideBarMutation {
  SetSideBarOpen = "SetPause"
}

export const enum SideBarGetter {
  GetSideBarOpen = "GetSideBarOpen"
}

export interface NavItem {
  icon: string;
  routeName: RouteName;
  defaultElement: string;
  text: string;
}
